import {apiService} from "../../components/Config/api.service";
const Deconnexion = async () => {
    apiService.logoutUser()
};

export default Deconnexion;